"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApiCall = void 0;
const react_1 = require("react");
const notistack_1 = require("notistack");
const react_intl_1 = require("react-intl");
const provider_api_1 = require("@framework/provider-api");
const TOO_MANY_POINTS_FALLBACK_RU = "Невозможно построить график. Сократите временной интервал.";
function readHttpStatus(e) {
    if (e && typeof e === "object" && "status" in e) {
        const s = e.status;
        return typeof s === "number" ? s : undefined;
    }
    return undefined;
}
function readErrorMessage(e) {
    if (e && typeof e === "object" && "message" in e) {
        const m = e.message;
        if (typeof m === "string" && m.trim().length > 0)
            return m;
    }
    return "";
}
const useApiCall = (fn, { success = true, error = true } = {}) => {
    const api = (0, provider_api_1.useApi)();
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const wrapper = (form, ...args) => {
        setIsLoading(true);
        return fn(api, ...args)
            .then((res) => {
            if (success) {
                (0, notistack_1.enqueueSnackbar)(formatMessage({ id: "snackbar.success" }), { variant: "success" });
            }
            return res;
        })
            .catch((e) => {
            if (error) {
                const status = readHttpStatus(e);
                const plainMessage = readErrorMessage(e);
                if (status === 400) {
                    if (e instanceof provider_api_1.ApiError) {
                        const fieldErrors = e.getLocalizedValidationErrors();
                        const keys = Object.keys(fieldErrors);
                        if (keys.length > 0) {
                            keys.forEach(key => {
                                form?.setError(key, { type: "custom", message: fieldErrors[key] });
                            });
                            return;
                        }
                    }
                    (0, notistack_1.enqueueSnackbar)(plainMessage || TOO_MANY_POINTS_FALLBACK_RU, { variant: "warning" });
                }
                else if (status) {
                    (0, notistack_1.enqueueSnackbar)(formatMessage({ id: `snackbar.${plainMessage}` }), { variant: "error" });
                }
                else {
                    console.error(e);
                    if (e?.name !== "AbortError") {
                        (0, notistack_1.enqueueSnackbar)(formatMessage({ id: "snackbar.error" }), { variant: "error" });
                    }
                }
            }
            else {
                throw e;
            }
        })
            .finally(() => {
            setIsLoading(false);
        });
    };
    return { fn: wrapper, isLoading };
};
exports.useApiCall = useApiCall;
//# sourceMappingURL=use-api-call.js.map